export default {
  Detail: require('./Detail').default
}